"use client";

import { cn } from "@/lib/utils";
import { CircularSpinner } from "./circular-spinner";
import { Button, ButtonProps } from "./ui/button";
import React from "react";

export type KButtonProps = ButtonProps & {
    isLoading?: boolean;
};

const KButton = ({
    isLoading,
    children,
    className,
    ...props
}: KButtonProps) => {
    return (
        <Button
            {...props}
            disabled={props.disabled}
            className={cn(
                { "z-50": isLoading },
                "relative flex items-center gap-2",
                className,
            )}
        >
            {/* HACK: When the `Link` component is passed to `KButton` as a child it is necessary that the `Link` is the direct children of `Button` */}
            {props.asChild ? (
                children
            ) : (
                <>
                    {isLoading && <CircularSpinner className="size-5" />}
                    {children}
                </>
            )}
        </Button>
    );
};

export { KButton };
